export default __webpack_public_path__ + "static/property002-89f62006be45acb6d140cb5f6b8959a2.png";